import "bootstrap/dist/css/bootstrap.min.css";

export { default } from "./App";
